import DateFnsUtils from '@date-io/date-fns';
import {
  Button, Card, CardContent,
  CardHeader,
  CircularProgress, Container,
  createTheme,
  Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider,
  FormControl,
  Grid,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import trLocale from "date-fns/locale/tr";
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getDifferenceInDays, getUser, moneyFormat, sc } from 'src/utils/Common';
import logger from 'src/utils/logger';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 5,
    minHeight: 580,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  container: {
    maxHeight: 440,
  },
}));

const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    },
  },
});
const localeMap = {
  tr: trLocale,
};

function Money() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [ResponseData, setResponseData] = React.useState([]);
  const [ResponseDataFull, setResponseDataFull] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = React.useState(today);
  const [bitisTarihi, setBitisTarihi] = React.useState(today);
  const [GarantiDisiToplamDeger, setGarantiDisiToplamDeger] = React.useState(0.00);
  const [GarantiIciToplamDeger, setGarantiIciToplamDeger] = React.useState(0.00);
  const [EkGarantiToplamDeger, setEkGarantiToplamDeger] = React.useState(0.00);
  const [TamamlayiciUrunToplamDeger, setTamamlayiciUrunToplamDeger] = React.useState(0.00);
  const [ToplamDeger, setToplamDeger] = React.useState(0.00);
  const [BakimToplamDeger, setBakimToplamDeger] = React.useState(0.00);
  const [TeknisyenValue, setTeknisyenValue] = React.useState("");
  const [TeknisyenData, setTeknisyenData] = React.useState([]);

  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };



  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };
  const handleSearch = () => {

    if (getDifferenceInDays(new Date(baslangicTarihi), new Date(bitisTarihi)) > 30) {
      setUyari("İki tarih aralığı 30 günden büyük olamaz!...");
      setOpen(true);
      return
    }


    setResponseData([]);
    setResponseDataFull([]);
    setTeknisyenValue(0);
    setLoading(true);
    axios.get('/GetArtemisTeknisyenGelir/' + SessionUser.ServiceShopId + '/' + SessionUser.OrganizationUserId + '/' + baslangicTarihi + '/' + bitisTarihi)
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseData([]);
        } else {
          setResponseData(Data);
          setResponseDataFull(Data);
          var TeknisyenData1 = [];

          Data.forEach(item => {
            const kontrol = TeknisyenData1.filter(d => d.KUL_TEK_KODU === item.KUL_TEK_KODU);
            if (kontrol.length === 0) {
              TeknisyenData1.push({ 'KUL_TEK_KODU': item.KUL_TEK_KODU, 'TEKNISYEN': item.KUL_TEK_KODU + ' ' + item.ADI + ' ' + item.SOYADI })
            }
          });
          setTeknisyenData(TeknisyenData1);

          var sum = 0.00;
          var sumIc = 0.00;
          var sumDis = 0.00;
          var sumEkGaranti = 0.00;
          var sumTamamlayiciUrun = 0.00;
          var sumBakimToplamDeger = 0.00;

          var Gelir1 = JSON.parse(JSON.stringify(Data));
          var GelirData = [];


          Gelir1.reduce(function (res, value) {
            if (!res[value.KUL_TEK_KODU]) {
              res[value.KUL_TEK_KODU] = { Id: value.KUL_TEK_KODU, KUL_TEK_KODU: value.KUL_TEK_KODU, ADI: value.ADI, SOYADI: value.SOYADI, GARANTI_TIPI: value.GARANTI_TIPI, IndirimliMalzeme: 0, Iscilik: 0, YanOdeme: 0, Toplam: 0 };
              GelirData.push(res[value.KUL_TEK_KODU])
            }
            res[value.KUL_TEK_KODU].IndirimliMalzeme += value.IndirimliMalzeme;
            res[value.KUL_TEK_KODU].Iscilik += value.Iscilik;
            res[value.KUL_TEK_KODU].YanOdeme += value.YanOdeme;
            res[value.KUL_TEK_KODU].Toplam += value.Toplam;
            return res;
          }, {});

          for (var i = 0; i < Gelir1.length; i++) {
            sum += Gelir1[i].Toplam;
            if (Gelir1[i].GARANTI_TIPI === "Garanti İçi") {
              sumIc += Gelir1[i].Toplam;
            }
            if (Gelir1[i].GARANTI_TIPI === "Garanti Dışı") {
              sumDis += Gelir1[i].Toplam;
            }
            if (Gelir1[i].GARANTI_TIPI === "EkGarantiSatış") {
              sumEkGaranti += Gelir1[i].Toplam;
            }
            if (Gelir1[i].GARANTI_TIPI === "TamamlayıcıUrun") {
              sumTamamlayiciUrun += Gelir1[i].Toplam;
            }
            if (Gelir1[i].GARANTI_TIPI === "Bakım") {
              sumBakimToplamDeger += Gelir1[i].Toplam;
            }
          }

          setGarantiDisiToplamDeger(sumDis);
          setGarantiIciToplamDeger(sumIc);
          setEkGarantiToplamDeger(sumEkGaranti);
          setTamamlayiciUrunToplamDeger(sumTamamlayiciUrun);
          setBakimToplamDeger(sumBakimToplamDeger);
          setToplamDeger(sum);



        }
        setLoading(false);
      }).catch(error => {
        setResponseData([]);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
  }

  useEffect(() => {
    var todosData1 = [];
    todosData1 = ResponseDataFull.filter(function (item) {
      return (
        sc(item.KUL_TEK_KODU, TeknisyenValue)
      );
    });
    setResponseData(todosData1);
    // eslint-disable-next-line
  }, [TeknisyenValue]);





  const handleChangeTeknisyen = (e) => {
    setResponseData([]);
    setTeknisyenValue(e.target.value);

  }



  return (
    <Page className={classes.root} title="Teknisyen Gelir">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardHeader title="Teknisyen Gelir" />
          <Divider />
          <CardContent>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <br />
            <Grid container spacing={1}>
              <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Başlangıç Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={baslangicTarihi}
                      onChange={e => handleDateChange(e, 1)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Bitiş Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={bitisTarihi}
                      onChange={e => handleDateChange(e, 2)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitMaterialImage}
                  onClick={() => handleSearch()}
                  endIcon={<SearchIcon />}>
                  Sorgula
                </Button>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <br />
            <Grid item xs={12} sm={12}>
              <FormControl variant="outlined" fullWidth className={classes.formControl}>
                <Select
                  native
                  onChange={(e) => handleChangeTeknisyen(e)}
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  fullWidth
                  value={TeknisyenValue}

                >
                  <option value="0" defaultValue="0">Teknisyen Seçiniz!...</option>
                  {TeknisyenData.map(p => {
                    return <option key={p.KUL_TEK_KODU} value={p.KUL_TEK_KODU}>{p.TEKNISYEN}</option>
                  })}
                </Select>
              </FormControl>
            </Grid>
            <br />
          </CardContent>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={5} align='right'><b>EkGarantiSatış Toplam</b></TableCell>
                  <TableCell align='right'>{
                  moneyFormat(
                    EkGarantiToplamDeger,
                      'try',
                      'try'
                    )}₺
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5} align='right'><b>Garanti İçi Toplam</b></TableCell>
                  <TableCell align='right'>{
                    moneyFormat(
                      GarantiIciToplamDeger,
                      'try',
                      'try'
                    )}₺
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5} align='right'><b>Garanti Dışı Toplam</b></TableCell>
                  <TableCell align='right'>
                  {
                  moneyFormat(
                    GarantiDisiToplamDeger,
                      'try',
                      'try'
                    )}₺
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5} align='right'><b>Tamamlayıcı Ürün Toplam</b></TableCell>
                  <TableCell align='right'>
                  {
                  moneyFormat(
                    TamamlayiciUrunToplamDeger,
                      'try',
                      'try'
                    )}₺
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5} align='right'><b>BakımSatış Toplam</b></TableCell>
                  <TableCell align='right'>
                  {
                  moneyFormat(
                    BakimToplamDeger,
                      'try',
                      'try'
                    )}₺
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5} align='right'><b>Toplam</b></TableCell>
                  <TableCell align='right'>
                  {
                  moneyFormat(
                    ToplamDeger,
                      'try',
                      'try'
                    )}₺
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          <br />
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Teknisyen</TableCell>
                  <TableCell>Garanti</TableCell>
                  <TableCell align='right'>Malzeme</TableCell>
                  <TableCell align='right'>İşçilik</TableCell>
                  <TableCell align='right'>YanÖdeme</TableCell>
                  <TableCell align='right'>Toplam</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ResponseData.map(row => (
                  <TableRow key={row.KUL_TEK_KODU}>
                    <TableCell>{row.KUL_TEK_KODU} {row.ADI} {row.SOYADI}</TableCell>
                    <TableCell>{row.GARANTI_TIPI}</TableCell>
                    <TableCell align='right'>{moneyFormat(row.Malzeme,'try','try')}₺</TableCell>
                    <TableCell align='right'>{moneyFormat(row.Iscilik,'try','try')}₺</TableCell>
                    <TableCell align='right'>{moneyFormat(row.YanOdeme,'try','try')}₺</TableCell>
                    <TableCell align='right'>{moneyFormat(row.Toplam,'try','try')}₺</TableCell>

                    


                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Card>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Money;
